import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=04c314db&scoped=true"
import script from "./Warning.vue?vue&type=script&setup=true&lang=js"
export * from "./Warning.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Warning.vue?vue&type=style&index=0&id=04c314db&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c314db",
  null
  
)

export default component.exports